
import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type PriceSelectProps = {
	selected: boolean
	qty: number
	px: number
	onSelect: () => void
}

const PriceSelect: FC<PriceSelectProps> = ({selected, qty, px, onSelect}) => {
	return (
		<div className={classNames({
			[styles.price]: true,
			[styles.selected]: selected,
		})} onClick={onSelect}>
			<div className={styles.radio} />
			<div className={styles.text}>
				<span>{qty} scan{qty !== 1 && 's'}</span>
			</div>
			<div>
				${px.toFixed(2)}
			</div>
		</div>
	);
};

export default PriceSelect;
